module.exports = __webpack_public_path__ + "img/voting-one-and-two-dude.bb57725f.svg";